import React from "react";

export function formatDate(dateString: string): string {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  
  // Check if date is valid
  if (isNaN(date.getTime())) {
    return "";
  }
  
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-indexed
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}.${month}.${year}. ${hours}:${minutes}`;
}

export const wrapLongNumber = (numberStr: string, interval: number): string => {
  let wrappedNumber = "";
  for (let i = 0; i < numberStr.length; i += interval) {
    wrappedNumber +=
      numberStr.substring(i, Math.min(i + interval, numberStr.length)) + " ";
  }
  return wrappedNumber.trim();
};

export function getMonthBoundaries(startDate: Date, endDate: Date): string {
  // Format the dates as "d.m.yyyy"
  const format = (date: Date) =>
    `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;

  // Combine the formatted first and last day of the month
  return `${format(startDate)} - ${format(endDate)}`;
}

/**
 * Formats the typeList value for display
 * @param typeList - The typeList value (e.g., "redovna", "popotrebi")
 * @returns Formatted string ("Redovan" or "Po potrebi")
 */
export function formatTypeList(typeList: string | null | undefined): string {
  if (!typeList) return "";
  if (typeList.toLowerCase() === "redovna" || typeList === "REGULAR") {
    return "Redovan";
  }
  if (typeList.toLowerCase() === "popotrebi" || typeList === "OCCASIONALLY") {
    return "Po potrebi";
  }
  return typeList;
}

/**
 * Formats start and end dates for display in evidence forms
 * @param startDate - Start date string or Date object
 * @param endDate - End date string or Date object
 * @returns JSX element with formatted dates on separate lines
 */
export function formatDateRange(
  startDate: string | Date | null | undefined,
  endDate: string | Date | null | undefined
): JSX.Element | null {
  if (!startDate && !endDate) return null;

  const formatSingleDate = (date: string | Date): string => {
    const d = typeof date === "string" ? new Date(date) : date;
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();
    const hours = d.getHours().toString().padStart(2, "0");
    const minutes = d.getMinutes().toString().padStart(2, "0");

    return `${day}.${month}.${year}. ${hours}:${minutes}`;
  };

  return (
    <div style={{ textAlign: "right" }}>
      {startDate && <div>{formatSingleDate(startDate)}</div>}
      {endDate && <div>{formatSingleDate(endDate)}</div>}
    </div>
  );
}
